export default __webpack_public_path__ + "static/media/人群_peoples.ca1f998c.svg";